import React from "react";
import {Slot} from "../../models";
import {Ages} from "../../utils/ages";


interface AvailabilityStatusChipsProps {
    slot: Slot;
    className?: string;
    waitingOrderNumber?: number;
    moveMode?: boolean;
}

const SlotAvailableLabel: React.FC<AvailabilityStatusChipsProps> = ({slot, className, waitingOrderNumber, moveMode}) => {
    // Same mode-conditional as SlotButtons: move mode's target signal is
    // canMoveTo, not canBook, otherwise the seat count reads blank on a move
    // target whose canBook is legitimately false (see WI-6/WI-7).
    const canBookTarget = moveMode ? slot.canMoveTo : slot.canBook;

    if (!slot.isBooked
        && slot.lessonDateTs > (new Ages()).subDays().toTs()
        && slot.bookingLimit > 0
        && slot.lessonDateTs
        && (canBookTarget || slot.canWait || slot.canCancelWait)
    ) {
        const waitingOfText = (slot.canCancelWait && !isNaN(parseInt(`${slot.profilePackageWaitingBookingOrder}`)) && `#${slot.profilePackageWaitingBookingOrder + 1} of `) || "";
        return (
            <span className={className}>
                {canBookTarget && slot.availableCount && `Available: ${(slot.availableCount > 0) ? slot.availableCount : 0}`}
                {(slot.canWait || slot.canCancelWait) && `Waiting: ${waitingOfText}${(slot.waitingBookingsCount > 0) ? slot.waitingBookingsCount : 0}`}
            </span>
        );
    } else {
        return null;
    }
};

export default SlotAvailableLabel;
